import React, { useState } from "react";
import Select, {components } from "react-select";
import { Field } from "formik";
import "./form-elements.scss";

// const customStyles = {
//   control: (provided) => ({
//     ...provided,
//     height: "40px",
//     borderRadius: "4px",
//     color: "#24272b",
//     border: "1px solid #e0e0e0",
//   }),
//   menu: (provided) => ({
//     ...provided,
//     zIndex: 2,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     color: state.isSelected ? "white" : "#292a2a",
//     fontSize: "1rem",
//     backgroundColor: state.isSelected ? "#0047ba" : "initial",
//     zIndex: 2,
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: "#9c9c9c",
//     fontSize: "1rem",
//   }),
//   indicatorSeparator: (provided) => ({
//     ...provided,
//     display: "none",
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     fontSize: "1rem",
//     top: "50%",
//   }),
//   Input: (provided) => ({
//     ...provided,
//     display: "none",
//   }),
// };

// const fruits = [
//   { label: "Mango", value: "mg" },
//   { label: "Guava", value: "gv" },
//   { label: "Peach", value: "pc" },
//   { label: "Apple", value: "ap" }
// ];

// const states = [
//   { label: "MN", value: "MN" },
//   { label: "CA", value: "CA" },
//   { label: "CT", value: "CT" },
//   { label: "MI", value: "MI" }
// ];

const InputOption = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: "inherit",
    display: "flex "
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style
  };

  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <input type="checkbox" checked={isSelected} />
      {children}
    </components.Option>
  );
};

const MultiSelect = (props) => {


  const options = props.multi
  ? [{ label: "Select All", value: "all" }, ...props.options]
  : props.options;

  return (
    <Field name={props.name}>
      {({ field, form, meta }) => {
        return (
          <div>
              <Select
                closeMenuOnSelect={false}
                defaultValue={props.defaultValueArr}
                isMulti
                allowSelectAll={true}
                placeholder={props.placeholder}
                options={options}
                components={{
                  Option: InputOption
                }}
                multi={props.multi}
                value={props.value ? props.value : null}
                className="basic-multi-select"
                classNamePrefix="select"
                isSearchable={false}
                isDisabled={props.disabled}
                noOptionsMessage={() => "No records"}
                isClearable={true}
                onChange={(selected, index) => {
                  props.multi &&
                  selected?.length &&
                  selected.find((option) => option.value === "all")
                    ? props.setMultiSelectVal(options.slice(1))
                    : !props.multi
                    ? props.setMultiSelectVal((selected && selected.value) || null)
                    : props.setMultiSelectVal(selected); 
                }}
              />
          
            {meta.touched && meta.error && (
              <p name={props.name + "Error"} className="error-message">
                {meta.error}
              </p>
            )}
          </div>
        );
      }}
    </Field>
  );
};
export default MultiSelect;
